var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 33,
    viewBox: "0 0 42 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Caminho_168",
    d: "M104.5 160h-39a1.5 1.5 0 0 0-1.5 1.5v30a1.5 1.5 0 0 0 1.5 1.5h39a1.5 1.5 0 0 0 1.5-1.5v-30a1.5 1.5 0 0 0-1.5-1.5zm-1.875 5.194v24.431h-35.25v-24.431l-1.294-1.008 1.842-2.367 2.006 1.561h30.145l2.006-1.561 1.842 2.367-1.3 1.008zm-2.55-1.819L85 175.094l-15.075-11.719-2.006-1.561-1.842 2.367 1.294 1.008 16.012 12.45a2.625 2.625 0 0 0 3.22 0l16.022-12.445 1.294-1.008-1.842-2.367-2 1.556z",
    "data-name": "Caminho 168",
    transform: "translate(-64 -160)",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.5b01cf4f.svg";
export { ForwardRef as ReactComponent };